module.exports = __webpack_public_path__ + "img/generationyouth-banner2.96960aa0.jpg";